import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface IState {
  duAnList?: any
  duAnDetail?: any
}

const initialState: IState = {
  duAnList: {},
  duAnDetail: {},
}

export const duAnDucks = createSlice({
  name: 'duAn',
  initialState,
  reducers: {
   
    getListDuAn: (state: RootState, action: PayloadAction<any>) => {
      state.duAnList = { loading: true, queryStr: action.payload }
    },
    getListDuAnSuccess: (state, action: PayloadAction<any>) => {
      state.duAnList = { loading: false, ...action.payload }
    },
    getListDuAnFail: (state, action: PayloadAction<any>) => {
      state.duAnList = { loading: false, ...action.payload }
    },
    
    getDetailDuAn: (state: RootState, action: PayloadAction<any>) => {
      state.duAnDetail = { loading: true, id: action.payload }
    },
    getDetailDuAnSuccess: (state, action: PayloadAction<any>) => {
      state.duAnDetail = { loading: false, ...action.payload }
    },
    getDetailDuAnFail: (state, action: PayloadAction<any>) => {
      state.duAnDetail = { loading: false, ...action.payload }
    },
    
  },
})

// Action creators are generated for each case reducer function
export const {
  getListDuAn,
  getListDuAnSuccess,
  getListDuAnFail,
  getDetailDuAn,
  getDetailDuAnSuccess,
  getDetailDuAnFail,
} = duAnDucks.actions

export default duAnDucks.reducer 